import api from '@/services/api.js';

export default {
    add(permissionsData){
        return api.post('/user-permissions', permissionsData);
    },
    update(permissionsId, formData){
        return api.put('/user-permissions/' + permissionsId, formData);   
    },
    getOne(permissionId){   
        return api.get(`/user-permissions/${permissionId}`);
    },
    getAll(){   
        return api.get('/user-permissions');
    },
    delete(permissionId){
        return api.delete('/user-permissions/' + permissionId);
    }
}